import React, { Component } from 'react';
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
// Requests
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig';
import Waiting from '../../../waiting';
// Images
import Logo from './../../../../../statics/img/souhoola_v2/souhoola.png';
import BackIcon from './../../../../../statics/img/souhoola_v2/back.svg';
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import Status from '../../components/IframeStatus/Status';
import {decode as base64_decode} from 'base-64';
import jwt_decode from "jwt-decode";
import OtpInput from 'react-otp-input';
import './Souhoola.css';

let resend_setInterval; 
let change_installment_setInterval; 

class Souhoola extends Component {

    constructor(props) {
        super(props)
        this.state = {
            //Public
            step: 1,
            waiting: false,
            error: false,
            error_message: "",
            public_error: false,
            public_error_message: "",
            // Step 1
            device: this.getMobileOperatingSystem(),
            Souhoola_link: "",
            phone_number: "",
            pin_code: "",
            // Step 2
            trnx_id: "",
            reference: "",
            Souhoola_token: "",
            installment_plans: [],
            selected_plan: {},
            selected_plan_index: "",
            change_installment_waiting: false,
            change_installment_counter: 2,
            down_payment: 0,
            down_payment_error: false,
            financed_amout: 0,
            admin_fees: 0,
            cash_amount: 0,
            agree: false,
            step_2_validations: [true, false, false],
            submit_step_2: false,
            // Step 3
            souhoola_trnx_id: "",
            // Step 4
            otp: "",
            otp_error: false,
            otp_error_message: "",
            resend: false,
            resend_counter: 30,
            resend_otp_times: 0,
            invalid_otp_times: 1,
            submit_step_4: false,
            // Status Screen
            status: null,
            status_message: "",
            redirection_url: "",
            // User Data
            user_data: "",
        };
    }
    componentDidMount(){
        if(this.state.device === "iOS"){
            this.setState({Souhoola_link: "https://apps.apple.com/eg/app/souhoola-%D8%B3%D9%87%D9%88%D9%84%D8%A9/id1514405177"});
        }else{
            this.setState({Souhoola_link: "https://onelink.to/7wdkm4"});
        }
        this.decodePaymentToken();
    }

    // Start Logic ..........................................................................

    // Step 1
    
    // decode payment token
    decodePaymentToken = () => {
        // decode from base64 format
        let base64 = base64_decode(this.props.payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        this.setState({user_data: jwt}, ()=>{
            this.setState({financed_amout: (this.state.user_data.amount_cents / 100) - this.state.down_payment})
        });
    }
    // Check device Type
    getMobileOperatingSystem = () => {
        var userAgent = navigator.userAgent || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
        return "unknown";
    }
    // Handle Back Button
    handleBack = () => {
        this.setState({step: this.state.step - 1, error: false, error_message :""});
    }
    // Validations
    requiredV = (value) => {
        if(validator.isEmpty(value)){
            return(
                // We can return string or jsx as the 'error' prop for the validated Component
                <div className="alert alert-danger" role="alert">
                    This field is required.
                </div>
            )
        }
    };
    phoneV = (value,props) => {
        if(props.isChanged === true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length !== 11){
                    return <div className="alert alert-danger" role="alert">Please enter a valid phone number.</div>;
                }
            }
        }
    };
    pinCodeV = (value,props) => {
        if(props.isChanged === true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length !== 5){
                    return <div className="alert alert-danger" role="alert">Please enter a valid pin code.</div>;
                }
            }
        }
    };

    // Step 2

    // Down payment change
    handle_down_payment_change = (value) => {
        clearInterval(change_installment_setInterval);
        this.setState({down_payment:value}, () => {
            if(value === ""){
                let new_state = {...this.state}
                new_state.down_payment_error = false;
                new_state.step_2_validations[0] = true;
                this.setState(new_state, ()=> {
                    this.check_step_2_validation()
                    this.handle_financed_amount_change();
                    this.handle_cash_amount_change();
                    this.start_change_installment_counter();
                });
            }else{
                if(!validator.isNumeric(value) || value > this.state.user_data.amount_cents / 100){
                    let new_state = {...this.state}
                    new_state.down_payment_error = true;
                    new_state.step_2_validations[0] = false;
                    this.setState(new_state, ()=> this.check_step_2_validation());
                }else{
                    let new_state = {...this.state}
                    new_state.down_payment_error = false;
                    new_state.step_2_validations[0] = true;
                    this.setState(new_state, ()=> {
                        this.check_step_2_validation()
                        this.handle_financed_amount_change();
                        this.handle_cash_amount_change();
                        this.start_change_installment_counter();
                    });
                }
            }
        });
    }
    // Handle select plan
    handle_select_plan = (plan, index) => {
        let new_state = {...this.state}
        new_state.selected_plan = plan;
        new_state.selected_plan_index = index;
        new_state.admin_fees = plan.adminFees;
        new_state.step_2_validations[1] = true;
        this.setState(new_state, ()=> {
            this.check_step_2_validation();
            this.handle_cash_amount_change();
        });
    }
    // Change Installment Counter 
    start_change_installment_counter = () => {
        clearInterval(change_installment_setInterval);
        change_installment_setInterval = setInterval(this.change_installment_calc, 1000);
    }
    change_installment_calc = () => {
        if(this.state.change_installment_counter > 0){
            this.setState({change_installment_counter: this.state.change_installment_counter - 1});
        }else{
            clearInterval(change_installment_setInterval);
            this.setState({change_installment_counter: 2}, () => {
                // Change installment plans
                this.change_installment_plans();
            });
        }
    }
    // Financed amount change
    handle_financed_amount_change = () => {
        this.setState({financed_amout: (this.state.user_data.amount_cents / 100) - Number(this.state.down_payment)});
    }
    // Cash amount change
    handle_cash_amount_change = () => {
        this.setState({cash_amount: Number(this.state.down_payment) + this.state.admin_fees});
    }
    // agreement checkbox change
    handle_agreement_change = () => {
        let new_state = {...this.state};
        new_state.agree = !this.state.agree;
        new_state.step_2_validations[2] = !this.state.agree;
        this.setState(new_state, ()=> this.check_step_2_validation());
    }
    // Check Step 2 validations
    check_step_2_validation = () => {
        if (this.state.step_2_validations[0] === true && this.state.step_2_validations[1] === true && this.state.step_2_validations[2] === true){
            this.setState({submit_step_2: true});
        }else{
            this.setState({submit_step_2: false});
        }
    }

    // Step 4

    // OTP Validation
    handle_otp_change = (value) => {
        this.setState({otp: value, error: false, error_message: ""}, () => {
            if(this.state.otp === ""){
                this.setState({otp_error: true, otp_error_message: "This field is required.", submit_step_4: false});
            }else if(this.state.otp.length !== 5){
                this.setState({otp_error: true, otp_error_message: "Please Enter a valid OTP", submit_step_4: false});
            }else{
                this.setState({otp_error: false, otp_error_message: "", submit_step_4: true});
            } 
        });
    }
    // handle Resend OTP
    handleResendOtp = () => {
        this.setState({resend_otp_times: this.state.resend_otp_times + 1}, () => {
            if(this.state.resend_otp_times === 4){
                this.cancelTrnx();
            }else{
                this.resendOtp();
            }
        });
    }
    // Resend OTP Counter 
    start_resend_counter = () => {
        this.setState({resend: true});
        clearInterval(resend_setInterval);
        resend_setInterval = setInterval(()=>this.resend_counter_calc(), 1000)
    }
    resend_counter_calc = () => {
        if(this.state.resend_counter > 0){
            this.setState({resend_counter: this.state.resend_counter - 1});
        }else{
            clearInterval(resend_setInterval);
            this.setState({resend_counter: 30, resend: false});
        }
    }

    // End Logic .........................................................................

    // Start Requests ....................................................................

    // 1st Request >> Check Data
    check_data = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/souhoola/check_data';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "phone_number": this.state.phone_number,
                "pin": this.state.pin_code,
                "integration_id": this.state.user_data.integration_id,
                "amount_cents": this.state.user_data.amount_cents,
                "accept_lang": 1,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({Souhoola_token: resp.data.Response.token}, () => {
                    this.load_installment_plans();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    // 2nd Request >> Load Installment Plans (Pay)
    load_installment_plans = () => {
        let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        let data = {
            "source": {
                "identifier": this.state.Souhoola_token,
                "subtype": "SOUHOOLAV2_ONLINE",
                "down_payment": this.state.down_payment,
                "accept_language": "EN"
            },
            "payment_token": this.props.payment_token
        }
        let jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        )
        .then((resp)=>{
            this.setState({waiting: false, error: false, error_message: "", installment_plans: resp.data.data.installment_plans, reference: resp.data.data.reference, trnx_id: resp.data.trx_id, step:2});
        })
        .catch((err)=>{
            if(err.response.data && err.response.data.message){
                this.setState({waiting: false, error: true, error_message: err.response.data.message});
            }else{
                this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
            }
        });
    }
    // 3rd Request >> Change Installment Plans
    change_installment_plans = () => {
        this.setState({change_installment_waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/acceptance/souhoola/change_installment';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "referance": this.state.reference,
                "down_payment": this.state.down_payment,
                "payment_token": this.props.payment_token,
                "accept_lang": 1
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                let new_state = {...this.state};
                new_state.change_installment_waiting = false;
                new_state.error = false;
                new_state.error_message = "";
                new_state.installment_plans = resp.data.installment_plans;
                new_state.selected_plan = {};
                new_state.selected_plan_index = "";
                new_state.step_2_validations[1] = false;
                new_state.admin_fees = 0;
                this.setState(new_state, () => {
                    this.check_step_2_validation();
                    this.handle_cash_amount_change();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({change_installment_waiting: false, public_error: true, public_error_message: err.response.data.message});
                }else{
                    this.setState({change_installment_waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    // 4th Request >> Installment Plan Review
    installment_plan_review = (e) => {
        e.preventDefault();
        this.setState({waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/acceptance/souhoola/installment_review';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "referance": this.state.reference,
                "promoCode": "M",
                "maxMonths": this.state.selected_plan.month,
                "loanAmount": this.state.user_data.amount_cents / 100,
                "downPayment": this.state.down_payment,
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: "", step: 3, souhoola_trnx_id: resp.data.Response.souhoolaTID});
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    // 5th Request >> Confirm Installment (Send OTP)
    confirm_installment = () => {
        this.setState({waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/acceptance/souhoola/confirm_installment';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "referance": this.state.reference,
                "souhoola_id": this.state.souhoola_trnx_id,
                "payment_token": this.props.payment_token,
                "accept_lang": 1
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: "", step: 4}, () => {
                    this.start_resend_counter();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    // 6th Request >> Confirm Trnx (Confirm OTP)
    confirmTrnx = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/souhoola/confirm_transaction';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction_id": this.state.trnx_id,
                "otp": this.state.otp,
                "payment_token": this.props.payment_token,
                "accept_lang": 1
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(resp.data.success === "true" && resp.data.pending === "false"){
                    // success
                    this.setState({waiting: false, error: false, error_message: "", status: "success", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === "false" && resp.data.pending === "true"){
                    // pending
                    this.setState({waiting: false, error: false, error_message: "", status: "pending", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === "false" && resp.data.pending === "false"){
                    // fail
                    this.setState({waiting: false, error: false, error_message: "", status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
            })
            .catch((err)=>{
                // Max Trials for Invalid OTP
                if(this.state.invalid_otp_times !== 3){
                    if(err.response.data && err.response.data.message){
                        this.setState({waiting:false, error: true, error_message: err.response.data.message});
                    }else{
                        this.setState({waiting:false, error: true, error_message: "Something went wrong please try again."});
                    }
                }else{
                    this.cancelTrnx();
                }
                // Increase Trials for Invalid OTP
                this.setState({invalid_otp_times: this.state.invalid_otp_times + 1});
            }); 
        });
    }
    // 7th Request >> Resend OTP
    resendOtp = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/souhoola/resend_otp';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "referance": this.state.reference,
                "payment_token": this.props.payment_token,
                "accept_lang": 1
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: ""}, () => {
                    this.start_resend_counter();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    // 8th Request >> Cancel Trnx
    cancelTrnx = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/cancel/transaction_decline';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "message": "Canceled By User",
                "response_code": "-1",
                "transaction_id": this.state.trnx_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // fail
                this.setState({waiting: false, public_error: false, public_error_message: "", status: "fail", redirection_url: resp.data.redirection_url});
            })
            .catch((err)=>{
                if(err && err.response && err.response.data && err.response.data.error){
                    this.setState({waiting: false, public_error: true, public_error_message: err.response.data.error});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong! please try again."});
                }
            });
        });
    }

    // End Requests ......................................................................

    // Start UI ..........................................................................

    renderStep1 = () => (
        <div className="iframe_content">
            <VForm onSubmit={()=>this.check_data()}>
                <div className="iframe_input">
                    <label>Phone number</label>
                    <VInput 
                        type="text"
                        name="phone_number"
                        id="phone_number"
                        maxLength="11"
                        value={this.state.phone_number}
                        onChange={(e)=>this.setState({phone_number: e.target.value})}
                        validations={[this.requiredV, this.phoneV]} 
                    />
                </div>
                <div className="iframe_input">
                    <label>Souhoola pin code</label>
                    <VInput 
                        type="text"
                        name="pin_code"
                        id="pin_code"
                        maxLength="5"
                        value={this.state.pin_code}
                        onChange={(e)=>this.setState({pin_code: e.target.value})}
                        validations={[this.requiredV, this.pinCodeV]} 
                    />
                </div>
                <p className="note">Don’t have a Souhoola Account? <a href={this.state.Souhoola_link}>Download app & Sign up now</a></p>
                {this.state.error &&
                    <div className="iframe_error">
                        {this.state.error_message}
                    </div>
                }
                <VButton>Proceed</VButton>
            </VForm>
        </div>
    )
    renderStep2 = () => (
        <div className="iframe_content">
            <div className="iframe_input">
                <label>Down payment</label>
                <input 
                    type="text"
                    name="down_payment"
                    id="down_payment"
                    value={this.state.down_payment}
                    onChange={(e)=>this.handle_down_payment_change(e.target.value)}
                />
                {this.state.down_payment_error && 
                    <div className="alert alert-danger" role="alert">
                        Please enter a valid number.
                    </div>
                }
            </div>
            <div className="installment_plans_container">
                <label>Select installment plan</label>
                {this.state.change_installment_waiting ?
                    <Waiting height='200px' />
                :
                    <div className="installment_plans">
                        {this.state.installment_plans.map((plan, index) => (
                            <div key={index} onClick={()=>this.handle_select_plan(plan, index)} className={`${this.state.selected_plan_index === index ? "selected" : ""}`}>
                                <label>
                                    <span className="circle"><span></span></span>
                                    <p>{plan.month} months</p>
                                    <span>{this.state.user_data.currency} {plan.installment} monthly</span>
                                </label>
                            </div>
                        ))}
                    </div>
                }
            </div>
            <div className="summary">
                <h4>Payment summary</h4>
                <p id="financed_amount">Financed amount <span>{this.state.user_data.currency} {this.state.financed_amout}</span></p>
                <hr />
                <p id="admin_fees">Admin fees <span>{this.state.user_data.currency} {this.state.admin_fees}</span></p>
                <div>
                    <label htmlFor="check_agree" className="custom_checkbox">
                        <input type="checkbox" id="check_agree" onChange={()=>this.handle_agreement_change()} checked={this.state.agree} />
                        <span className="check_mark"></span>
                    </label>
                    <span>I agree to pay <span id="cash_amount">{this.state.user_data.currency} {this.state.cash_amount}</span> in cash upon delivery</span>
                </div>
            </div>
            {this.state.error &&
                <div className="iframe_error">
                    {this.state.error_message}
                </div>
            }
            <button disabled={!this.state.submit_step_2} onClick={(e)=>this.installment_plan_review(e)}>Proceed</button>
        </div>
    )
    renderStep3 = () => (
        <div className="iframe_content">
            <div className="summary">
                <p>Down payment <span>{this.state.user_data.currency} {this.state.down_payment}</span></p>
                <hr className="full"/>
                <p>Installment plan <span>{this.state.selected_plan.month} months <br/>{this.state.user_data.currency} {this.state.selected_plan.installment} monthly</span></p>
                <hr className="full"/>
                <p>Financed amount <span>{this.state.user_data.currency} {this.state.financed_amout}</span></p>
                <hr className="full"/>
                <p>Admin fees <span>{this.state.user_data.currency} {this.state.admin_fees}</span></p>
                <hr className="full"/>
            </div>
            {this.state.error &&
                <div className="iframe_error">
                    {this.state.error_message}
                </div>
            }
            <button onClick={()=>this.confirm_installment()}>Proceed</button>
        </div>
    )
    renderStep4 = () => (
        <div className="iframe_content text-center">
            <h1>Verification</h1>
            <p>Verification Please enter the 5-digit code sent to<br/>{this.state.phone_number}</p>
            <OtpInput 
                numInputs={5} 
                value={this.state.otp}
                onChange={(value) => this.handle_otp_change(value)} 
                isInputNum
                containerStyle="OtpInput"
                placeholder="•••••"
            />
            {this.state.otp_error &&
                <div className="alert alert-danger" id="otp_error">
                    {this.state.otp_error_message}
                </div>
            }
            <div className="resend_otp">
                <p>
                    Didn’t receive code?
                    {this.state.resend?
                        <span>Send again in<span>{this.state.resend_counter}</span> sec.</span>
                    :
                        <span className="send_again" onClick={()=>this.resendOtp()}>Send again</span>
                    }
                </p>
            </div>
            {this.state.error &&
                <div className="iframe_error">
                    {this.state.error_message}
                </div>
            }
            <button disabled={!this.state.submit_step_4} id="confirm_otp" onClick={()=>this.confirmTrnx()}>Confirm</button>
        </div>
    )

    // End UI ..........................................................................

    render() {
        return (
            <div className="iframe_page">
                <div className="iframe_container souhoola_container">
                    {(this.state.step !== 1 && this.state.status === null && !this.state.waiting && !this.state.public_error ) && 
                        <>
                            <span onClick={()=>this.handleBack()} className="back_btn"><img src={BackIcon} alt="Back" /> Back</span>
                            <span onClick={()=>this.cancelTrnx()} className="cancel_btn"><span>X</span> Cancel</span>
                        </>
                    }
                    {this.state.status === null &&
                        <div className="iframe_header">
                            <img src={Logo} alt="Souhoola"/>
                        </div>
                    }
                    {this.state.waiting ?
                        <Waiting height='350px' />
                    :
                        this.state.public_error ?
                            <div className="iframe_error public_error">
                                {this.state.public_error_message}
                            </div>
                        :
                            this.state.status == null ?
                                <>
                                    {this.state.step === 1 && this.renderStep1()}
                                    {this.state.step === 2 && this.renderStep2()}
                                    {this.state.step === 3 && this.renderStep3()}
                                    {this.state.step === 4 && this.renderStep4()}
                                </>
                            :
                                <Status
                                    status={this.state.status}
                                    status_message={this.state.status_message}
                                    gateway_name="Souhoola"
                                    redirection_url={this.state.redirection_url}
                                />
                    }
                    <div className="iframe_footer">
                        <span>Powered by</span>
                        <img src={paymobLogo} alt="Paymob" className="paymob" />
                    </div>
                </div>
            </div>
        )
    }
}
export default Souhoola;